export const abaeva = {
  id: 'abaeva',
  name: {
    ru: 'Абаева Ажар Поштайқызы',
    kz: 'Абаева Ажар Поштайқызы',
  },
  position: {
    ru: 'Врач спортивной медицины (резидентура)',
    kz: 'Спорт медицинасы дәрігері (резидентура)',
  },
  department: 'sportmed',
  image: '/team_photoes/new/abaeva.png',
  experience: {
    ru: 'Резидентура: 2023–2026',
    kz: 'Резидентура: 2023–2026',
  },
  education: {
    ru: `2022 — Медицинский университет города Семей
2023–2026 — Резидентура по специальности «Спортивная медицина»`,
    kz: `2022 — Семей қаласының медицина университеті
2023–2026 — «Спорт медицинасы» мамандығы бойынша резидентура`,
  },
};
